import { render } from "./ServicesSubCategoryDetailsView.vue?vue&type=template&id=406b3bd2&scoped=true"
import script from "./ServicesSubCategoryDetailsView.vue?vue&type=script&lang=js"
export * from "./ServicesSubCategoryDetailsView.vue?vue&type=script&lang=js"

import "./ServicesSubCategoryDetailsView.vue?vue&type=style&index=0&id=406b3bd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406b3bd2"]])

export default __exports__